module.exports = __webpack_public_path__ + "img/brand4.ccb6ce71.png";